import { showView } from '../actions/publicActions';
import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';

export function deepLinkSharedSpaceConfigRouteHandler() {
    showView('SharedSpaceConfig');
    setPopoutChildState(PopoutChildState.Ready);
}
